import { Action, Level, PermissionOutput, PermissionScope } from '@app/models/users';

export const getRuleValue = (permissionScope: PermissionScope, action: Action, roles?: PermissionOutput[]): Level =>
  roles
    ? roles.find((el) => el.permission_scope === permissionScope)?.rules.find((el) => el.action === action)?.level ||
      Level.Denied
    : Level.Denied;
